import React, { useEffect, useState } from "react";
import { Form, Input, Button, message, Select, InputNumber, Row, Col } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import MainCard from "components/MainCard";
import { dispatch } from "store/index";
import {
  FetchCreateEmailSetting,
  FetchUpdateEmailSetting,
} from "store/action/index";
const { Option } = Select;

const EmailSetting = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [loadinBtn, setLoadingBtn] = useState(false)
  let params = { team_id: localStorage.getItem("teams_id") }

  const isEditing = location.state ? true : false;
  const initialData = location.state ? location.state : null;

  useEffect(() => {
    if (isEditing && initialData) {
      form.setFieldsValue({
        hostname: initialData.hostname,
        username: initialData.username,
        password: initialData.password,
        port: initialData?.port,
        from_address: initialData?.from_address,
        from_name: initialData?.from_name,
        encryption_method: initialData?.encryption_method,
        active: initialData.active == 1 ? true : false,
      });
    }
  }, [form, initialData, isEditing]);

  const onFinish = (values) => {
    setLoadingBtn(true)
    if (isEditing) {
      message.success("Email setting updated successfully!");
      const payload = {
        ...(values && { id: initialData?.id, _method: "PUT" }),
        hostname: values.hostname,
        username: values.username,
        password: values.password,
        port: values.port,
        encryption_method: values.encryption_method,
        active: values.active,
        from_address: values?.from_address,
        from_name: values?.from_name,
      };
      dispatch(FetchUpdateEmailSetting({ fieldData: payload, setLoadingBtn: setLoadingBtn, params }));
      navigate("/settings/all-email-setting");
    } else {
      message.success("Email setting created successfully!");
      dispatch(FetchCreateEmailSetting({ fieldData: values, setLoadingBtn: setLoadingBtn, params }));
      navigate("/settings/all-email-setting");
    }
  };

  return (
    <MainCard>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="hostname"
              label="Hostname"
              tooltip="Enter the hostname"
              rules={[{ required: true, message: "Please enter the hostname" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="username"
              label="Username"
              tooltip="Enter the username"
              rules={[{ required: true, message: "Please enter the username" }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="password"
              label="Password"
              tooltip="Enter the password"
              rules={[{ required: true, message: "Please enter the password" }]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="port"
              label="Port"
              tooltip="Enter the port number"
              rules={[{ required: true, message: "Please enter the port number" }]}
            >
              <InputNumber style={{ width: "100%" }} min={1} max={65535} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="from_address"
              label="From Address"
              tooltip="Enter the sender's email address"
              rules={[
                { required: true, message: "Please enter the from address" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="from_name"
              label="From Name"
              tooltip="Enter the sender's name"
              rules={[{ required: true, message: "Please enter the from name" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="encryption_method"
              label="Encryption Method"
              tooltip="Select the encryption method"
              rules={[
                { required: true, message: "Please select the encryption method" },
              ]}
            >
              <Select placeholder="Select encryption method">
                <Option value="tls">tls</Option>
                <Option value="ssl">ssl</Option>
                <Option value="starttls">starttls</Option>
                <Option value="none">none</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="active"
              label="Status"
              tooltip="Select the active status"
              rules={[{ required: true, message: "Please select the status" }]}
            >
              <Select>
                <Option value={true}>Active</Option>
                <Option value={false}>Deactive</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify="end">
          <Col span={24} style={{ textAlign: "right" }}>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loadinBtn} className="mt-4">
                {isEditing ? "Update" : "Submit"}
              </Button>
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </MainCard>
  );
};

export default EmailSetting;
